import * as types from '../mutation-types'
import {
  verifyUserDocuments,
  linkSocialByFB,
  sendTicket,
  generateAuthToken
  // userVerifyHyperVerge
} from '../api/user'

const state = {
  active_step: 1,
  formInfoVerifyAccount: {},
  ekyc_provider: 'HV',
  errorCodeEKYC: ''
}

const getters = {
  ekycProvider: (state) => state.ekyc_provider,
  errorCodeEKYC: (state) => state.errorCodeEKYC
}

const actions = {
  nextStep({ commit }, step) {
    commit(types.SET_ACTIVE_STEP_VERIFY_ACCOUNT, step)
  },

  /* eslint-disable */
  verifyUserDocuments({ commit }, user_id) {
    return new Promise((resolve, reject) => {
      let param = { user_id: user_id }
      verifyUserDocuments(param)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  linkSocial({ commit }, param) {
    return new Promise((resolve, reject) => {
      linkSocialByFB(param)
        .then((resp) => {
          resolve(resp)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  sendTicket({ commit }, param) {
    return new Promise((resolve, reject) => {
      sendTicket(param)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /* eslint-enable */

  setFormInfoVerifyAccount({ commit }, data) {
    commit(types.SET_FORM_INFO_VERIFY_ACCOUNT, data)
  },

  setEKYCProvider({ commit }, provider) {
    commit(types.SET_EKYC_PROVIDER, provider)
  },

  /* eslint-disable */
  generateAuthToken({ commit }) {
    return new Promise((resolve, reject) => {
      generateAuthToken()
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  setErrorCodeEKYC({ commit }, code) {
    commit(types.SET_ERROR_CODE_EKYC, code)
  }

  // verifyHyperVerge({commit}, data) {
  //     let formData = new FormData()

  //     formData.append('user_id', data.user_id),
  //     formData.append('doc_type', data.doc_type)
  //     formData.append('file', data.file)
  //     formData.append('data_extracted', data.data_extracted)

  //     return new Promise((resolve, reject) => {
  //         userVerifyHyperVerge(formData).then(response => {
  //             if(response) {
  //                 resolve(response)
  //             }
  //         }).catch(error => {
  //             reject(error)
  //         })
  //     })
  // }

  /* eslint-enable */
}

const mutations = {
  [types.SET_ACTIVE_STEP_VERIFY_ACCOUNT](state, step) {
    state.active_step = step
  },

  [types.SET_FORM_INFO_VERIFY_ACCOUNT](state, data) {
    state.formInfoVerifyAccount = { ...data }
  },

  [types.SET_EKYC_PROVIDER](state, data) {
    state.ekyc_provider = data
  },
  [types.SET_ERROR_CODE_EKYC](state, data) {
    state.errorCodeEKYC = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
